import React, { ReactNode } from 'react';
import './ExportHideout.css';
type Props = {
  children: ReactNode;
};
/**
 * The hideout renders children in an invisible way (h-0 w-0)
 * on the area big enough (2000x1000 px, can be increased if necessary) to not cause scrollbar on the content.
 * It is used to make a DOM snapshot for the ppt export that would include the whole content
 */
function ExportHideout({ children }: Props) {
  return (
    <div className="export-hideout h-0 w-0 overflow-hidden">
      <div className="export-canvas w-screen">
        <div className="export-canvas-wrapper w-fit h-fit">{children}</div>
      </div>
    </div>
  );
}

export { ExportHideout };
